import { Form } from 'react-bootstrap';

/** Cuándo avisarle, en meses desde hoy. 0 = cuando se pueda (entra directo a "Para avisar"). */
export const PLAZOS_VOLVER_A_CONTACTAR = [
    { meses: 0, etiqueta: 'Cuando se pueda' },
    { meses: 1, etiqueta: 'En 1 mes' },
    { meses: 3, etiqueta: 'En 3 meses' },
    { meses: 6, etiqueta: 'En 6 meses' },
];

/** 'YYYY-MM-DD' de hoy más N meses, en hora local (toISOString correría la fecha a UTC). */
export function fechaEnMeses(meses, desde = new Date()) {
    const fecha = new Date(desde.getFullYear(), desde.getMonth() + meses, desde.getDate());
    const mm = String(fecha.getMonth() + 1).padStart(2, '0');
    const dd = String(fecha.getDate()).padStart(2, '0');
    return `${fecha.getFullYear()}-${mm}-${dd}`;
}

/** El `avisarDesde` que se manda al backend: null = cuando se pueda. */
export function avisarDesdeParaPlazo(meses) {
    return Number(meses) > 0 ? fechaEnMeses(Number(meses)) : null;
}

/**
 * "☐ Volver a contactarlo  [Cuando se pueda ▾]", en un solo renglón.
 *
 * Es una decisión secundaria que se toma al cerrar la atención, con la persona enfrente o la
 * próxima esperando: no puede pesar más que el resultado, que es lo obligatorio. Por eso no lleva
 * nota propia (lo que el operador lee en el listado es la observación del motivo de no avance) ni
 * fecha a mano (los cuatro plazos cubren el uso real).
 *
 * Con `conCasilla={false}` se muestra solo el desplegable (el modal del histórico, donde abrirlo
 * ya es la decisión de agregarlo).
 */
export default function VolverAContactarEnUnRenglon({
    agregar = true, onAgregar, meses, onMeses, conCasilla = true, idPrefijo = 'vac',
}) {
    return (
        <div className="d-flex flex-wrap align-items-center gap-2">
            {conCasilla ? (
                <Form.Check
                    type="checkbox"
                    id={`${idPrefijo}-agregar`}
                    className="mb-0"
                    label="Volver a contactarlo"
                    checked={agregar}
                    onChange={(e) => onAgregar(e.target.checked)}
                />
            ) : (
                <label htmlFor={`${idPrefijo}-plazo`} className="mb-0">Avisarle</label>
            )}
            <Form.Select
                id={`${idPrefijo}-plazo`}
                size="sm"
                // paddingRight a mano: el tema (bootstrap-tema.css) redefine el padding entero de
                // .form-select-sm y le saca el lugar de la flecha, que quedaba encima del texto.
                style={{ width: 'auto', paddingRight: '2rem' }}
                aria-label="Cuándo avisarle"
                disabled={!agregar}
                value={meses}
                onChange={(e) => onMeses(Number(e.target.value))}
            >
                {PLAZOS_VOLVER_A_CONTACTAR.map((p) => (
                    <option key={p.meses} value={p.meses}>{p.etiqueta}</option>
                ))}
            </Form.Select>
        </div>
    );
}
